<template>
  <div class="default-layout">
    <VContainer>
      <VRow>
        <VCol cols="12" sm="4">
          <Sidebar />
        </VCol>
        <VCol cols="12" sm="8">
          <div class="page-wrapper">
            <h1 class="page-wrapper__title">{{ this.$route.name }}</h1>
            <div class="page-wrapper__content">
              <RouterView />
            </div>
          </div>
        </VCol>
      </VRow>
    </VContainer>
  </div>
  <FixedWhatsUp />
</template>
<script>
import Sidebar from '@/components/common/Sidebar/Sidebar.vue';
import FixedWhatsUp from '@/components/common/FixedWhatsUp/FixedWhatsUp.vue';
export default {
  components: {
    Sidebar,
    FixedWhatsUp
  }
};
</script>
